import { render, staticRenderFns } from "./LoginSingleLayout.vue?vue&type=template&id=87a9921c&scoped=true"
import script from "./LoginSingleLayout.vue?vue&type=script&lang=js"
export * from "./LoginSingleLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginSingleLayout.vue?vue&type=style&index=0&id=87a9921c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a9921c",
  null
  
)

export default component.exports